export default __webpack_public_path__ + "media/images/icons/envelope-5f8516ae6be123ed26e6a6b68a1c4cb2.svg";